import React from 'react'
import {  
    Button,
    Stack,
} from '@mui/material'
import Title from './Title'
import Paragraph from './Paragraph'
import { Link } from 'react-router-dom'

const TradeIn = () => {

    return (
        <Stack 
        component='section'
        direction="column"
        justifyContent= 'center'
        alignItems='center'
        sx={{
            py: 10,
            // mx: 6,
            backgroundColor: '#060f5e',
            color:'white'
        }}
        >
            <Title 
            text={
                'Join Us'
                } 
            textAlign={'center'}
            />
            <Paragraph 
            text={
                'Partner with us to expand your offerings and provide a wider range of applications for your customers. We welcome distributors and robotics companies to collaborate and integrate our modular solutions for enhanced versatility.'}
            maxWidth = {'sm'}
            mx={0}
            textAlign={'center'}
            />
            <Button component={Link} 
            to={'/contact'}
            variant="contained" 
            type="submit"
            size="medium"
            sx= {{ 
                fontSize: '0.9rem',
                textTransform: 'capitalize', 
                py: 2,
                px: 4,
                mt: 3, 
                mb: 2,
                borderRadius: 0,
                backgroundColor: '#14192d',
                "&:hover": {
                    backgroundColor: '#1e2a5a',
                }
            }}
            >
                get in touch
            </Button>
 
        </Stack>
    )
}

export default TradeIn;